<img
  alt="error.svg"
  class="mx-auto"
  src="assets/core/error.svg"
/>

<div class="portal-subheading">The offer has expired.</div>

<p class="text-balance">
  We’re sorry that we are unable to proceed with your CIMB FlexiPay Loan Application. Please contact the Business Call Centre at (65) 6438
  7888 for further assistance.
</p>
